export function paymentTypeFromOrderGroup(context: Record<string, any>) {
  if (!context.orderForm) return null;

  const transactions = context.orderForm.paymentData?.transactions || [];
  if (!transactions.length) return null;

  const payments = transactions[0]?.payments || [];
  if (!payments.length) return null;

  const name = payments[0]?.paymentSystemName?.toLowerCase() || '';
  const paymentTypeMap = [
    ['pix parcel', 'pix parcelado'],
    ['pix', 'pix'],
    ['apple', 'apple pay'],
    ['google', 'google pay'],
    ['boleto', 'boleto'],
    ['paypal', 'paypal'],
    ['cred', 'cartão'],
    ['visa', 'cartão'],
    ['master', 'cartão'],
    ['amex', 'cartão'],
    ['elo', 'cartão'],
    ['hiper', 'cartão'],
    ['diner', 'cartão'],
    ['deb', 'cartão'],
  ];

  const match = paymentTypeMap.find(([key]) => name.includes(key));

  return match ? match[1] : null;
}
